import React from 'react'
import { StyleSheet } from 'react-native'

import { B3, B4, B5, Stack, YStack, colors } from '@zet/design-system'
import { ZetCoinsFilled } from '@zet/homepage-widgets'
import { i18n } from '@zet/localization'
import { PaymentStatus } from '@zet/utils/Constants'
import moment from 'moment'

import BonusBanner from './bonusBanner'

const PayoutCards = ({ item: payment, data, leadDetails }) => {
  return (
    <Stack>
      {payment?.status === PaymentStatus.PENDING ? (
        <Stack className="bg-secondary-10 mx-3 my-2 rounded">
          <BonusBanner data={data} payment={payment} />
          <YStack className="py-4/2 px-2">
            <B4 className="text-grays-70">
              {i18n.t('payment.paymentDueOn', {
                date: moment.utc(payment?.payoutDate).format('DD-MMM-YYYY'),
              })}
            </B4>
            <B3 className="text-primary-200">
              {leadDetails?.isKycDone
                ? i18n.t('payment.paymentPending', {
                    amount: payment?.commission,
                    date: moment.utc(payment?.payoutDate).format('DD-MMM-YYYY'),
                  })
                : i18n.t('payment.paymentPendingCompleteKyc', {
                    amount: payment?.commission,
                  })}
            </B3>
          </YStack>
        </Stack>
      ) : (
        <></>
      )}

      {payment?.status === PaymentStatus.PAID ? (
        <Stack className="bg-success-8 mx-3 my-2 rounded">
          <BonusBanner data={data} payment={payment} />
          {payment?.coins && (
            <B5
              className="mx-2 -mb-2 mt-2 self-start rounded border bg-white p-2"
              style={styles.coinsBorder}
            >
              <Stack>
                <ZetCoinsFilled className="top-1 mr-1" height={19} width={19} />
              </Stack>
              {i18n.t('payoutBreakoutLoyalty.zetCoins')}
            </B5>
          )}
          <YStack className="py-4/2 px-2">
            <B4 className="text-grays-70">
              {i18n.t('payment.paidOn', {
                date: moment.utc(payment?.payoutDate).format('DD-MMM-YYYY'),
              })}
            </B4>
            {payment?.commission && (
              <B3 className="text-success-150">
                {i18n.t('payment.paymentSuccessfull', {
                  amount: payment?.commission,
                })}
              </B3>
            )}
            {Boolean(payment?.coins) && (
              <B3 className="text-success-150">
                {i18n.t('payoutBreakoutLoyalty.transfered', {
                  coin: payment?.coins,
                })}
              </B3>
            )}
          </YStack>
        </Stack>
      ) : (
        <></>
      )}

      {payment?.status === PaymentStatus.FAILED ? (
        <Stack className="bg-warning-10 mx-3 mb-2 rounded">
          <BonusBanner data={data} payment={payment} />
          <YStack className="py-4/2 px-2">
            <B4 className="text-grays-70">
              {i18n.t('payment.paymentFailed', {
                date: moment.utc(payment?.payoutDate).format('DD-MMM-YYYY'),
              })}
            </B4>
            <B3 className="text-error-200">
              {i18n.t('payment.paymentFailedDescription', {
                amount: payment?.commission,
              })}
            </B3>
          </YStack>
        </Stack>
      ) : (
        <></>
      )}

      {payment?.status === PaymentStatus.REJECTED ? (
        <Stack className="mb-4/2 bg-error-10 mx-3 rounded">
          <BonusBanner data={data} payment={payment} />
          <YStack className="py-4/2 px-2">
            <B4 className="text-grays-70">
              {i18n.t('payment.paymentRejected', {
                amount: payment?.commission,
              })}
            </B4>
            <B3 className="text-error-200">
              {payment?.failureReason
                ? payment?.failureReason
                : i18n.t('payment.rejectionReason')}
            </B3>
          </YStack>
        </Stack>
      ) : (
        <></>
      )}

      {payment?.status === PaymentStatus.LOCKED ? (
        <Stack className="mb-4/2 bg-grays-5 mx-3 rounded">
          <BonusBanner data={data} payment={payment} />
          <YStack className="py-4/2 px-2">
            <B4 className="text-grays-70">
              {i18n.t('payment.paymentLocked', {
                amount: payment?.commission,
              })}
            </B4>
            <B3 className="text-grays-60">
              {i18n.t('loyaltyDetails.becomeExpert')}
            </B3>
          </YStack>
        </Stack>
      ) : (
        <></>
      )}
    </Stack>
  )
}
export default PayoutCards
const styles = StyleSheet.create({
  coinsBorder: {
    borderColor: colors.success[30],
  },
  failedErrorBorder: {
    borderColor: colors.error[20],
  },
  pendingBorderColor: {
    borderColor: colors.primary[30],
  },
  lockedBorderColor: {
    borderColor: colors.grays[40],
  },
})
